import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useFgp } from "@/context/FgpContext";
import { Logo } from "@/components/Logo";
import { Loader2 } from "lucide-react";

// Handles the return from Emergent Google OAuth: exchanges the session_id for our session.
export default function AuthCallback() {
  const { googleSession } = useFgp();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = (window.location.hash || "").match(/session_id=([^&]+)/);
    (async () => {
      if (!m) return navigate("/login", { replace: true });
      try {
        await googleSession(decodeURIComponent(m[1]));
        navigate("/app/dashboard", { replace: true });
      } catch {
        navigate("/login?error=google", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 gap-6">
      <Logo className="h-24" />
      <div className="flex items-center gap-2 text-slate-500 text-sm">
        <Loader2 className="h-4 w-4 animate-spin" /> Signing you in…
      </div>
    </div>
  );
}
